import React, { useRef, useEffect, useState } from "react";
import "../../css/style.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/API_Client";
import {
  Alert,
  Button,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import "../analytics/analytics.css";
import LoadingLogoPage from "../loadingPage/loadingPage";

const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

const MasqueradeLogin = () => {
  const {
    initiateMasqueradeSamlLogin,
    getUserDetails,
    defaultPageLink,
  } = useAuth();
  const [masqueradeEmail, setMasqueradeEmail] = useState("");
  const [signInError, setSignInError] = useState("");
  const [showErrors, setShowErrors] = useState(false);
  const [masqueradeEmailValid, setMasqueradeEmailValid] = useState(true);
  const [mobileLayout, setMobileLayout] = useState(false);
  const [showImagePanel, setShowImagePanel] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (getUserDetails()) {
      navigate(localStorage.getItem("currentPathname") || defaultPageLink());
    }
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width : 1000px)");
    setMobileLayout(mediaQuery.matches);
    const updateShouldRenderMobileNavbar = (event) => {
      setMobileLayout(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", updateShouldRenderMobileNavbar);
    localStorage.clear();
  }, []);

  //SignIn Ref's

  const setErrorMsg = (errMsg) => {
    setSignInError(errMsg);
    setShowAlert(
      errMsg?.response?.status === 401 ||
      errMsg?.response?.status === 500 ||
      errMsg?.response?.status === 403
    );
  };

  const signInSubmit = async (event) => {
    event.preventDefault();
    setShowErrors(true);

    if (!emailRegex.test(masqueradeEmail)) {
      setMasqueradeEmailValid(false);
      setErrorMsg("Please provide a valid masquerade email address");
      return;
    } else {
      setMasqueradeEmailValid(true);
    }

    setTimeout(() => {
      setShowAlert(false);
      setSignInError("");
    });

    if (masqueradeEmail === "") {
      setErrorMsg("Please provide your login details to continue");
      return;
    }

    setErrorMsg("");
    setShowLoader(true);
    initiateMasqueradeSamlLogin(masqueradeEmail);
  };

  const prodDnsPrefix = "masquerade-merchant";
  const sandboxDnsPrefix = "masquerade-sandbox-merchant";
  const [selectedEnv, setSelectedEnv] = useState("");
  useEffect(() => {
    setSelectedEnv(window.location.hostname.split(".")[0]);
  }, []);

  const handleChange = (event, value) => {
    if (value === 'masquerade-merchant') {
      window.location.href = `https://masquerade-merchant.boxpay.in`;
    } else {
      window.location.href = `https://${value}.boxpay.tech`;
    }
  };

  const loginHeader = () => {
    return (
      <div className="login-header">
        <div className="header-boxpay-logo">
          <a href="" className="header-boxpay-logo">
            <img
              src="/assets/boxpayLogo.svg"
              alt="BoxPay"
              style={{ width: "100%", height: "100%" }}
            />
          </a>
        </div>
        <div>
          <Tabs
            value={selectedEnv}
            onChange={handleChange}
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
          >
            <Tab
              id="simple-tab-0"
              value={prodDnsPrefix}
              label={"Production"}
              style={{
                color: "#403E9F",
                fontFamily: "Poppins",
                textTransform: "none",
                borderBottom:
                  selectedEnv === prodDnsPrefix ? "2px solid #403E9F" : "none",
              }}
            />
            <Tab
              id="simple-tab-1"
              value={sandboxDnsPrefix}
              label={"Sandbox"}
              style={{
                color: "#403E9F",
                fontFamily: "Poppins",
                textTransform: "none",
                borderBottom:
                  selectedEnv === sandboxDnsPrefix
                    ? "2px solid #403E9F"
                    : "none",
              }}
            />
          </Tabs>
        </div>
      </div>
    );
  };

  const [showAlert, setShowAlert] = useState(false);
  return (
    <>
      {showLoader && (<div style={{ left: 100, width: "100%", position: "fixed" }}><LoadingLogoPage></LoadingLogoPage></div>)}
      <div className="login-root">
        {mobileLayout && loginHeader()}
        {showImagePanel === false && mobileLayout === true ? (
          <></>
        ) : (
          <div className="login-img-panel">
            <div className="login-img-container">
              <img
                src={"/assets/boxPayLoginFrame.svg"}
                alt="Login Page"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            <div className="login-img-text-container">
              <Typography className="login-img-txt-1">
                Streamlining payments worldwide,
              </Typography>
              <Typography className="login-img-txt-2">
                One transaction at a time
              </Typography>
            </div>
          </div>
        )}

        <div className="login-content">
          {!mobileLayout && loginHeader()}

          {" "}
          <div
            onClick={() => setShowImagePanel(false)}
            className="login-main-form"
          >
            <Typography className="login-main-title1">Login</Typography>
            <Typography className="login-main-title2">
              Welcome back! Please enter your details
            </Typography>
            <TextField
              fullWidth
              sx={{
                height: mobileLayout ? "40px" : "50px",
                marginTop: mobileLayout ? "20px" : "48px",
              }}
              placeholder="Email to masquerade"
              value={masqueradeEmail}
              onChange={(e) => setMasqueradeEmail(e.target.value)}
              error={showErrors && (!masqueradeEmail || !masqueradeEmailValid)}
            />
            {showErrors && (!masqueradeEmail || !masqueradeEmailValid) ? (
              masqueradeEmail ? (
                <div className="email-error">
                  <img src="/assets/errorOutline.svg" alt="Error" />
                  <Typography
                    className="labelRegularRes"
                    sx={{
                      color: "#EA1238 !important",
                    }}
                  >
                    Please enter a valid masquerade email address
                  </Typography>
                </div>
              ) : (
                <div className="email-error">
                  <img src="/assets/errorOutline.svg" alt="Error" />
                  <Typography
                    className="labelRegularRes"
                    sx={{
                      color: "var(--Comms-Negative, #B9232F) !important",
                    }}
                  >
                    Masquerading Email is required
                  </Typography>
                </div>
              )
            ) : signInError?.response?.status === 400 ? (
              <div className="email-error">
                <img src="/assets/errorOutline.svg" alt="Error" />
                <Typography
                  className="labelRegularRes"
                  sx={{
                    color: "var(--Comms-Negative, #B9232F) !important",
                  }}
                >
                  Masquerading Email Address doesn’t exist. Please check again and retry
                </Typography>
              </div>
            ) : (
              <div className="email-error"></div>
            )}
            <Button
              fullWidth
              sx={{
                marginTop: mobileLayout ? "18px" : "46px",
                backgroundColor: "#403E9F",
                height: mobileLayout ? "40px" : "50px",
                "&:disabled": {
                  backgroundColor: "rgba(241, 241, 241, 1)",
                  color: "rgba(201, 201, 204, 1)",
                },
              }}
              variant="contained"
              onClick={signInSubmit}
              className={
                masqueradeEmail
                  ? "colorHover disableState"
                  : "RemoveHover disableState"
              }
              disabled={masqueradeEmail?.length === 0}
            >
              <div
                style={{
                  color:
                    masqueradeEmail ? "#fff" : "rgba(201, 201, 204, 1)",
                  fontFamily: "Poppins",
                  fontSize: mobileLayout ? "16px" : "20px",
                  alignItems: "center",
                  textTransform: "none",
                }}
              >
                Masquerade
              </div>
            </Button>

            <div>
              {signInError && (
                <Alert
                  icon={false}
                  sx={{
                    display: showAlert ? "flex" : "none",
                    alignItems: "center",
                  }}
                  className={` ${signInError?.response?.status === 403
                    ? "alert-red"
                    : "alert"
                    }`}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "4px",
                      justifyContent: "center",
                      alignItems: "flex-start",
                    }}
                  >
                    <img
                      src={
                        signInError?.response?.status === 403
                          ? "/assets/warningSignRed.svg"
                          : "/assets/warningSign.svg"
                      }
                      style={{
                        width: mobileLayout ? "12px" : "24px",
                        paddingTop: mobileLayout ? "5px" : "0px",
                      }}
                    />

                    <div
                      style={{
                        marginTop:
                          signInError?.response?.status === 403 ? "" : "4px",
                        marginLeft: "4px",
                        fontFamily: "Poppins",
                        fontSize: mobileLayout ? "12px" : "14px",
                        fontWeight: "500",
                      }}
                    >
                      {signInError?.response?.data?.message}
                    </div>
                  </div>
                </Alert>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MasqueradeLogin;
